import isEqual from 'lodash/isEqual';
class UtmFields {
    constructor() {
        var _a;
        this.fields = [];
        this.getUtmRecord = () => {
            var _a, _b;
            const record = {};
            const parsedQueryString = (_b = (_a = document.location.search.split('?')[1]) === null || _a === void 0 ? void 0 : _a.split('&')) !== null && _b !== void 0 ? _b : [];
            parsedQueryString.map((item) => {
                const [fullKey, value] = item === null || item === void 0 ? void 0 : item.split('=');
                const [keyCategory, keyName] = fullKey.split('_');
                if (keyCategory === 'utm') {
                    record[keyName] = value;
                }
            });
            return Object.keys(record).length > 0 ? record : null;
        };
        const storedString = (_a = localStorage.getItem(UtmFields.localStorageId)) !== null && _a !== void 0 ? _a : '[]';
        try {
            this.fields = JSON.parse(storedString);
        }
        catch (_b) {
            this.fields = [];
        }
        //this clears the old object version if needed
        if (!Array.isArray(this.fields)) {
            this.fields = [];
        }
        this.update();
        localStorage.setItem(UtmFields.localStorageId, JSON.stringify(this.fields));
    }
    //check the query string and if there an new/updated utm values, add them to the fields
    update() {
        var _a;
        const record = this.getUtmRecord();
        if (record) {
            if (!isEqual(this.fields[this.fields.length - 1], record)) {
                this.fields.push(record);
            }
        }
        return (_a = this.fields) !== null && _a !== void 0 ? _a : undefined;
    }
    toString() {
        return JSON.stringify(this.fields);
    }
}
UtmFields.localStorageId = '_coin_utm';
export default UtmFields;
//# sourceMappingURL=UtmFields.js.map